
import * as ipxRuntime$PDAZjAXBVhDekIMMYk9kXb4Sn6y4mnWJEjrTQgZwxQ0 from '/codebuild/output/src3720478101/src/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$PDAZjAXBVhDekIMMYk9kXb4Sn6y4mnWJEjrTQgZwxQ0, defaults: {} }
}
        